import React from 'react';
import { motion } from 'framer-motion';

// Import images from the local directory
import image1 from '../../Images/map_navigator.png';

const Portfolio = () => {
    // Portfolio data
    const portfolioItems = [
        {
            id: 1,
            image: '/5.png',
            title: 'GitPulse',
            category: 'CLI Tool',
            shortDescription: 'Go CLI tool for visualizing Git contributions with heatmaps.',
            description: 'A lightweight Go CLI tool that visualizes Git contributions across local repositories, offering a GitHub-style heatmap of your coding activity.',
            githubLink: 'https://github.com/aryanndwi123/gitpulse',
        },
        {
            id: 2,
            image: '/4.png',
            title: 'CLI Code AI',
            category: 'CLI Tool',
            shortDescription: 'AI-powered CLI assistant for code generation and assistance.',
            description: 'An AI-powered CLI code assistant with authentication system, enabling developers to interact with AI models through a modern command-line interface.',
            githubLink: 'https://github.com/aryanndwi123/cli-code-ai',
        },
        {
            id: 3,
            image: image1,
            title: 'ROUTE ROVER',
            category: 'Software',
            shortDescription: 'Map navigator using A* pathfinding algorithm.',
            description: 'Route Rover is a map navigator application using the A* algorithm.',
            githubLink: 'https://github.com/yourusername/route-rover',
        },
    ];

    // Animation variants
    const containerVariant = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    };

    return (
        <section className="bg-gray-50 dark:bg-gray-900 py-12">
            <div className="container px-6 mx-auto">
                <motion.h1
                    className="text-3xl font-semibold text-center text-gray-800 dark:text-white"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Projects
                </motion.h1>
                <motion.p
                    className="mt-4 text-center text-gray-600 dark:text-gray-400"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    Explore my portfolio of projects below.
                </motion.p>

                <motion.div
                    className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 lg:grid-cols-3"
                    variants={containerVariant}
                    initial="hidden"
                    animate="visible"
                >
                    {portfolioItems.map((item) => (
                        <motion.div
                            key={item.id}
                            className="relative group overflow-hidden rounded-lg shadow-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700"
                            variants={itemVariant}
                        >
                            {/* Background Image */}
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                            />

                            {/* Hover Layer */}
                            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 px-4">
                                <h3 className="text-lg font-semibold text-white mb-1">
                                    {item.title}
                                </h3>
                                <p className="text-sm text-gray-200 text-center mb-3 max-w-xs">
                                    {item.shortDescription}
                                </p>
                                <a
                                    href={item.githubLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    View on GitHub
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Portfolio;